import { EmptyControl } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { HvlQueryModel } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrHrmDetailTypeQueryModelCT')
export class HrmDetailTypeQueryModelCT extends HvlQueryModel {
    @EmptyControl()
    @JsonProperty('tableName', String, true)
    tableName?: string = null;
}
